import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import usersApi from "../../api/userApi";
import Pagination from "../../components/Pagination";

const Level2FA = () => {
 const [level2Admins, setLevel2Admins] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    fetchLevel2Admins();
  }, [page, pageSize, sortedColumn, sortOrder]);

  const fetchLevel2Admins = async () => {
    try {
      const response = await usersApi.getUsersList(
        page,
        pageSize,
        sortedColumn,
        sortOrder,
      "L2_ADMIN",
      );
      setLevel2Admins(response.data.content || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      console.error("Error fetching level 2  admins:", error);
      setLevel2Admins([]);
      setTotalPages(0);
      console.error("Error fetching level 2 admins", error);
    }
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("userCreditListAdmin", selectedPage);
  };

  return (
    <div>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          {level2Admins.map((level2Admin, index) => (
            <tr key={level2Admin.userId}>
              <td>{level2Admin.userId}</td>
              <td>{level2Admin.userName}</td>
              <td>{level2Admin.userEmail}</td>
              <td>{level2Admin.countryName}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div style={{ marginTop: "auto" }}>
        {level2Admins.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </div>
  );
};

export default Level2FA
